<script setup>
import { ref, watch, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { useEquipmentsStore } from '@/store/equipments.js';

import Hero from '@/components/Hero.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import EmptyList from '@/components/Empty.vue';
import Equipment from '@/components/Equipment.vue';
import SkeletonCard from '@/components/SkeletonCard.vue';

const store = useEquipmentsStore();
const route = useRoute();
const hasFetchedOnce = ref(false);

watch(
  () => route.query.cat,
  async (newSlug) => {
    store.urlCategory = newSlug || '';
    store.selectedCategory = newSlug || 'All';
    if (store.categories.length === 0) {
      await store.fetchCategories();
    }
    await store.applyFilters();
    hasFetchedOnce.value = true;
  },
  { immediate: true }
);

onUnmounted(() => {
  store.urlCategory = '';
  store.selectedCategory = 'All';
});
</script>

<template>
  <Hero />
  <Breadcrumb />

  <!-- Skeleton while loading -->
  <div v-if="store.isLoadingEquipments || !hasFetchedOnce" class="container mx-auto px-1.5 py-4 sm:px-4">
    <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-1.5 sm:gap-4">
      <SkeletonCard v-for="i in 10" :key="`skel-cat-detail-${i}`" />
    </div>
  </div>

  <EmptyList v-else-if="store.filteredEquipments.length === 0" />

  <div v-else>
    <div class="p-2 w-full hidden md:block">
      <Equipment />
    </div>
    <div class="p-2 w-full text-xs md:hidden">
      <Equipment />
    </div>
  </div>
</template>
